import { createSelector } from 'reselect';
import { StoreState } from 'src/store/reducers';
import { IVendor } from '../../types/vendor';

export const Selector = (state: StoreState) => state.vendors.data.list;

export const selectNameVendors = createSelector(Selector, (items): { label: string; value: number | string }[] => {
    const arrSel: { label: string; value: number | string }[] = [];

    items.forEach((item: IVendor) => {
        arrSel.push({ label: item?.name, value: item.id });
    });
    arrSel.sort((a: SelectObject, b: SelectObject) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    return arrSel;
});
export const miniLoaderForSelector = (state: StoreState) => state.students.miniLoaderFor;
export const loaderSelector = (state: StoreState) => state.students.inProgress;
